import React, { Component } from "react";
import { Button, Tooltip, Collapse } from "antd";
import { ProfileOutlined, RightOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";
import { ChrysanthemumLoading } from '@beisen-phoenix/loading';
import StatusTag, { Size } from '@beisen-phoenix/status-tag';
import { $yellow, $green, $blue } from '@beisen-phoenix/style-token'
import EmptyV from "@beisen-phoenix/themed-empty";
import FormEmpty from "@beisen-phoenix/themed-empty/lib/icons/Form";
import axios from "axios";

import "./assessment-common.scss";

const { Panel } = Collapse;

export default class AssessmentCommon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      assessmentList: [],
      errorMessage: '',
    };
  }

  componentDidMount() {
    this.handleCorsOrigin();
    this.getInit();
  }

  handleCorsOrigin = () => {
    try {
      const domainFields = document.domain.split(".");
      const len = domainFields.length;
      document.domain = domainFields[len - 2] + "." + domainFields[len - 1];

      setTimeout(() => {
        // 获取top的颜色值，设置颜色变量值
        ['--skin-css-var-S2', '--skin-css-var-S3', '--skin-css-var-M7', '--skin-css-var-S4'].map(id => {
          const value = getComputedStyle(window.parent.document.documentElement).getPropertyValue(id);
          document.documentElement.style.setProperty(id, value);
        })
      }, 100);
    } catch (error) {}
  };

  getInit = () => {
    this.setState({ loading: true });
    const { personType } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    const commonParamater = urlParams.get("commonParamater");
    const tenantId = urlParams.get("tenantId");
    const params = {
      tenantId,
      commonParamater,
      personType,
    };

    axios
      .get(`/api/ZhongJinGuoJi/GetPath`, { params })
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.code === 200) {
            this.setState({ assessmentList: res.data.data || [] });
          } else {
            this.setState({ errorMessage: res.data.message });
          }
        }
      })
      .catch(() => {
        this.setState({ errorMessage: "接口异常，请联系管理员！" });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  renderItems(details) {
    return (
      <div className="zjgj-custom-assessment-items">
        {(details || []).map((item, index) => {
          const { tag, totalScore, reportDetails = [] } = item || {};
          return (
            <div
              className="zjgj-custom-assessment-item"
              key={`${item}_${index}`}
            >
              <div className="zjgj-custom-assessment-item__card-tag-score">
                <div className="zjgj-custom-assessment-item__card-tag">
                  {tag}
                </div>
                <div className="zjgj-custom-assessment-item__card-score">
                  <Tooltip title={totalScore}>{totalScore}</Tooltip>
                </div>
              </div>

              {(reportDetails || []).map((dItem) => {
                const { reportId, reportName, iframeUrl } = dItem || {};

                return (
                  <div
                    className="zjgj-custom-assessment-item__card-report"
                    key={reportId}
                  >
                    <Button
                      icon={<ProfileOutlined />}
                      type="link"
                      onClick={() => window.open(iframeUrl)}
                    >
                      {reportName}
                      <RightOutlined />
                    </Button>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  }

  renderExpandIcon(panelProps) {
    const { isActive } = panelProps;
    const icon = isActive ? <UpOutlined /> : <DownOutlined />;
    const text = isActive ? '收起报告' : '展开报告';

    return (
      <span className="expand-btn">{text}{icon}</span>
    )
  }

  renderItemWrapper() {
    const { assessmentList } = this.state;
    // 0: 未开始， 1: 作答中， 2:已完成，3:已过期
    const statusColorSlot = [ $yellow, $blue, $green ,$yellow ];
    const statusText = ['应聘者未开始', '应聘者作答中', '应聘者已完成', '应聘者逾期未答'];

    return (assessmentList || []).map((item, index) => {
      const { activityName, invitationStatus, invitationTime, reportDetails } = item;

      return (
        <div className="zjgj-custom-assessment-items-wrapper" key={`items-wrapper-${index}`}>
          <div className="first-line">
            <span className="activity-name">{activityName}</span>
            <StatusTag text={statusText[invitationStatus]} size={Size.small} color={statusColorSlot[invitationStatus]} />
          </div>
          <div className="second-line">
            <Collapse collapsible="icon" ghost expandIcon={(panelProps) => this.renderExpandIcon(panelProps)} expandIconPosition="end">
              <Panel header={invitationTime ? <span className="invite-time">邀请时间：{invitationTime}</span> : ''}>
                {this.renderItems(reportDetails)}
              </Panel>
            </Collapse>
          </div>
        </div>
      )
    })
  }

  render() {
    const { loading, assessmentList, errorMessage } = this.state;
    const showItem = !loading && !errorMessage && assessmentList && assessmentList.length;
    const empty = !loading && !errorMessage && (!assessmentList || !assessmentList.length);
    const showErrorMessage = !loading && errorMessage;

    return (
      loading ? 
        <div className="zjgj-custom-assessment-loading">
          <ChrysanthemumLoading />
        </div>
      :
      <div className="zjgj-custom-assessment-wrapper">
        {showItem ? this.renderItemWrapper() : ''}
        {empty ? (
          <EmptyV
            image={<FormEmpty openChangeSkin={true} />}
            description={"这里什么都没有..."}
            size={"large"}
          />
        ) : ''}
        {showErrorMessage ? <div className="error">{errorMessage}</div> : ''}
      </div>
    );
  }
}
